<template>
  <div>
    <h1 style="font-size: 24px; color: black;">充值管理</h1>
    <el-card shadow="false">
      <el-button type="primary" style="margin-left:8px" @click="goToManageGroup">管理分组</el-button>
    </el-card>
    <el-tabs type="card" v-model="selectedRechargeType" @tab-click="changeTab" >
      <el-tab-pane v-for="item in iosRechargeSelections.rechargeGroups"  :name="item.id+''" :key="item.id" :label="item.name">
      </el-tab-pane>
    </el-tabs>
    <h1>
      <el-table :data="list" border>
        <el-table-column label="ID" prop="id" align="center"></el-table-column>
        <el-table-column label="名称" prop="name" align="center"></el-table-column>
        <el-table-column label="英文名称" prop="nameEN" align="center"></el-table-column>
        <!--        <el-table-column label="繁体中文名称" prop="nameTCN" align="center"></el-table-column>-->
        <el-table-column label="苹果商品ID" width="160px" prop="appleProductId" align="center"></el-table-column>
        <el-table-column label="价格" align="center" prop="price" ><template slot-scope="scope">
          <span>{{ scope.row.price.toFixed(2) }}</span>
        </template></el-table-column>
        <el-table-column label="上架时间" align="center">
          <el-table-column label="开始时间"  width="160px" align="center">
            <template slot-scope="scope">
              {{ scope.row.startTime | dateTimeFormat}}
            </template>
          </el-table-column>
          <el-table-column label="结束时间"  width="160px" align="center">
            <template slot-scope="scope">
              {{ scope.row.endTime | dateTimeFormat}}
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="奖励"  align="center" prop="rewards">
          <template slot-scope="scope">
            {{ scope.row.rewards | iosRewardFormat}}
          </template>
        </el-table-column>
        <el-table-column label="图片" align="center" width="100px">
          <template slot-scope="scope">
            <template>
              <img :src="VUE_APP_CDN_URL+scope.row.image" width="60px" height="60px"/>
            </template>
          </template>
        </el-table-column>
        <el-table-column label="状态" align="center" width="100px">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.state"
                :active-value="true"
                active-text="开"
                inactive-text="关"
                @change="switchState(scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="重开首充" align="center" width="100px">
          <template slot-scope="scope">
            <el-button v-show="scope.row.enableFirstRecharge" type="danger" size="small" plain @click="updateReEnableFirstRecharge(scope.row)">重开</el-button>
          </template>
        </el-table-column>
        <!--        <el-table-column label="首充状态" align="center" width="100px">-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-switch-->
        <!--                v-model="scope.row.enableFirstRecharge"-->
        <!--                :active-value="true"-->
        <!--                active-text="开"-->
        <!--                inactive-text="关"-->
        <!--                @change="switchState(scope.row)">-->
        <!--            </el-switch>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <!--        <el-table-column label="周期状态" align="center" width="100px">-->
        <!--          <template slot-scope="scope">-->
        <!--            <el-switch-->
        <!--                v-model="scope.row.enableDuration"-->
        <!--                :active-value="true"-->
        <!--                active-text="开"-->
        <!--                inactive-text="关"-->
        <!--                @change="switchState(scope.row)">-->
        <!--            </el-switch>-->
        <!--          </template>-->
        <!--        </el-table-column>-->
        <!--        <el-table-column label="周期天数" prop="durationDays" align="center"></el-table-column>-->
        <!--        <el-table-column label="周期限制次数" prop="durationLimitNumber" align="center"></el-table-column>-->
        <!--        <el-table-column label="总限制次数" prop="totalLimitNumber" align="center"></el-table-column>-->
        <el-table-column label="创建日期" prop="createDt"  align="center" >
          <template slot-scope="scope">
            {{ scope.row.createDt | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="更新日期" prop="updateDt"  align="center" >
          <template slot-scope="scope">
            {{ scope.row.updateDt | dateTimeFormat}}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center">
          <template slot-scope="scope" >
            <el-button plain size="mini" type="primary" @click="showDetails('编辑条目',scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-button type="primary" v-show="selectedRechargeType!=='0'" style="margin-left:0px" @click="showDetails('添加条目')">添加条目</el-button>
    </h1>
    <el-pagination
        v-show="selectedRechargeType!=='0'"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page.page"
        :page-sizes="[10,20,30]"
        :page-size="page.size"
        layout="total, sizes, prev, pager, next"
        :total="page.totalElements">
    </el-pagination>
    <el-dialog :title="dialogTitle" center :visible.sync="dialogVisible" width="1200px">
      <el-form :model="itemForm">
        <el-form-item label="名称 :" :label-width="labelWidth">
          <el-input type="text" v-model="itemForm.name" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="英文名称 :" :label-width="labelWidth">
          <el-input type="text" v-model="itemForm.nameEN" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <!--        <el-form-item label="繁体中文名称 :" :label-width="labelWidth">-->
        <!--          <el-input type="text" v-model="itemForm.nameTCN" maxlength="50" show-word-limit></el-input>-->
        <!--        </el-form-item>-->
        <el-form-item label="苹果商品ID :" :label-width="labelWidth">
          <el-input type="text" v-model="itemForm.appleProductId" maxlength="50" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="状态 :" :label-width="labelWidth">
          <el-switch
              v-model="itemForm.state"
              :active-value="true"
              active-text="开"
              inactive-text="关">
          </el-switch>
        </el-form-item>
        <el-form-item label="开启首充 :" :label-width="labelWidth">
          <el-switch
              v-model="itemForm.enableFirstRecharge"
              :active-value="true"
              active-text="开"
              inactive-text="关">
          </el-switch>
        </el-form-item>
        <!--        <el-form-item label="重开首充 :" :label-width="labelWidth">-->
        <!--          <el-switch-->
        <!--              v-model="itemForm.reEnableFirstRecharge"-->
        <!--              :active-value="true"-->
        <!--              active-text="开"-->
        <!--              inactive-text="关">-->
        <!--          </el-switch>-->
        <!--        </el-form-item>-->
        <!--        <el-button v-show="itemForm.reEnableFirstRecharge===true" size="mini" type="primary" @click="updateReEnableFirstRecharge(itemForm.id)">重开首充</el-button>-->
        <!--        <el-form-item label="重开首充 :" :label-width="labelWidth">-->
        <!--          <el-button type="danger" size="small" plain @click="updateReEnableFirstRecharge(itemForm.id)">重开</el-button>-->
        <!--        </el-form-item>-->
        <el-form-item label="价格 :"  :label-width="labelWidth">
          <el-input-number  size="mini" :min="1.00" v-model="itemForm.price"></el-input-number>
        </el-form-item>
        <el-form-item label="上架时间 :"  :label-width="labelWidth">
          <el-date-picker
              v-model="itemForm.startTime"
              type="datetime"
              value-format="yyyy-MM-dd"
              placeholder="开始时间">
          </el-date-picker>
          <span>至</span>
          <el-date-picker
              v-model="itemForm.endTime"
              type="datetime"
              placeholder="结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="角标类型 :"  :label-width="labelWidth">
          <el-select v-model="itemForm.cornerType" >
            <el-option
                v-for="item in iosRechargeSelections.corners"
                :label="item.name"
                :value="item.id"
                :key="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item  :label-width="labelWidth">
          <el-button  size="mini" type="primary" @click="addGoods">新增奖励</el-button>
          <el-table :data="itemForm.goodsList"
                    border
                    :fit="true">
            <el-table-column label="规则编号" type="index" width="100px" align="center"></el-table-column>
            <el-table-column label="奖励"   align="center">
              <template slot-scope="scope">
                <el-select  v-model="scope.row.goodsId" placeholder="请选择" >
                  <el-option
                      v-for="item in goods"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column label="奖励数量"   align="center">
              <template slot-scope="scope">
                <el-input-number  size="mini" :min="1" v-model="scope.row.number"></el-input-number>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="80px">
              <template slot-scope="scope">
                <el-button  circle icon="el-icon-minus" size="mini" type="danger"
                            @click.native.prevent="reduceGoods(scope.$index,itemForm.goodsList)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="图片 :" >
          <el-upload :headers="headers"
                     class="avatar-uploader"
                     :action="uploadURL"
                     :show-file-list="false"
                     :on-success="handleCISuccess"
                     :before-upload="beforeAvatarUpload">
            <img v-if="itemForm.image" :src="VUE_APP_CDN_URL+itemForm.image" class="avatar">
            <i v-else class="el-icon-picture avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <div style="text-align: center;">
          <el-button type="primary" @click="confirmForm" >提 交</el-button>
          <el-button type="info" @click="cancelForm">取 消</el-button>
        </div>
      </el-form>
    </el-dialog>

  </div>
</template>

<script>
import {
  searchTask,
  updateTaskState,
  goodsSelections,
  saveTask,
  searchRecharge,
  updateRechargeState, saveRecharge, rechargeSelections, updateReEnableFirstRechargeState
} from "@/http/iosApi";
import store from '@/store';
import settingMix from '@/utils/mix/common-setting';
import utils from "@/utils";
export default {
  name: "RechargeManage",
  mixins: [settingMix],
  data(){
    return{
      VUE_APP_IOS_URL:'',
      VUE_APP_CDN_URL:'',
      selectedRechargeType:'0',
      needIosRechargeSelections:true,
      uploadURL: process.env.VUE_APP_IOS_URL + "block/upload",
      labelWidth: '110px',
      headers:{},
      page: {
        size: 10,
        page: 1,
        totalElements: null
      },
      list:[],
      queryData:{
        "orders":"id asc ",
      },
      goods:[],
      iosRechargeSelections:{rechargeGroups:[]},
      // rechargeGroupState:{1:true,2:true},
      dialogTitle:'',
      dialogVisible:false,
      itemForm: {},
      image:'',
      corners:[],
      bidTimeModel : new Date()
    }
  },
  methods:{
    formatDate: function(column) {
      return utils.DateUtil.formatDate(column, "YYYY-MM-DD")
    },
    changeTab(tab){
      this.$store.commit('changeSelectedRechargeType', tab.name);
      this.selectedRechargeType = tab.name;
      this.page.page = 1;
      this.search();
    },
    queryRechargeSelections(onComplete) {
      rechargeSelections().then(r =>{
        this.iosRechargeSelections = r.data.info;
        if (this.iosRechargeSelections.rechargeGroups.length === 0) {
          this.selectedRechargeType = '0';
        } else {
          this.selectedRechargeType = this.iosRechargeSelections.rechargeGroups[0].id.toString();
        }
        onComplete();
      })
    },
    search(){
      console.log("search->selectedRechargeType:", this.selectedRechargeType)
      if (this.selectedRechargeType.length > 0) {
        this.queryData.rechargeType = parseInt(this.selectedRechargeType);
        this.queryData.size = this.page.size;
        this.queryData.page = this.page.page;
        searchRecharge(this.queryData).then(resp=>{
          this.list= resp.data.info.content;
          this.page.totalElements = resp.data.info.totalElements
          console.log("result:", this.list);
        })
      }
    },
    handleSizeChange(size) {
      this.page.size = size;
      this.search();
    },
    handleCurrentChange(page) {
      this.page.page = page;
      this.search();
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isGif = file.type === "image/gif";
      const isMp4 = file.type === "video/mp4";
      const isPG = isJPG || isPNG || isGif;
      if (isPG) {
        //限制图片格式为jpg / png
        if (file.size / 1024 / 1024 > 1) {
          this.$message.error("上传图片应该小于1M，请重新上传");
          return false;
        }
      } else if (isMp4) {
        if (file.size / 1024 / 1024 > 5) {
          this.$message.error("上传视频应该小于5M，请重新上传");
          return false;
        }
      }
    },
    switchState(row) {
      let rechargeId = row.id;
      let state  = row.state?1:0;
      updateRechargeState(rechargeId,state).then(resp=>{
        if (resp.data.status===1){this.search();}
      })
    },
    updateReEnableFirstRecharge(row) {
      console.log("updateReEnableFirstRecharge->data:", row)
      this.$confirm('确认继续?', '提示', {
        cancelButtonClass: 'btn-custom-cancel',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        updateReEnableFirstRechargeState(row.id).then(resp=>{
          if (resp.data.status===1){this.search();}
        })
      }).catch(() => {
      })
    },
    // switchGroupState(v) {
    //   console.log("switchGroupState->v:", v);
    //   this.rechargeGroupState[this.selectedRechargeType] = v;
    //   console.log("switchGroupState->rechargeGroupState:", this.rechargeGroupState);
    // },
    goodsSelections(){
      goodsSelections().then(resp =>{
        this.goods = resp.data.info;
      })
    },
    goToManageGroup() {this.$router.push({ path: '/rechargeGroupManage'});},
    showDetails(title, row) {
      this.goodsSelections();
      this.itemForm = {
        "id": 0,
        "name": "",
        "nameEN": "",
        "nameTCN": "",
        "appleProductId": "",
        "state":true,
        "price":1.00,
        "image":'',
        "rechargeType":this.selectedRechargeType,
        "groupId":this.selectedRechargeType,
        "cornerType": 0,
        "goodsList": [],
      };
      this.dialogTitle = title;
      this.dialogVisible = true;
      function chargeReward(list) {
        let newRewards =[];
        list.forEach((item)=>{
          newRewards.push({
            goodsId:item.goods.id,
            number:item.number
          })
        });
        return newRewards
      }

      if (row) {
        console.log("-------->row:", row)
        this.itemForm = {
          "id": row.id,
          "name": row.name,
          "nameEN": row.nameEN,
          "nameTCN": row.nameTCN,
          "appleProductId": row.appleProductId,
          "state":row.state,
          "price":row.price,
          "rechargeType":row.rechargeType,
          "groupId":row.groupId,
          "cornerType": row.cornerType,
          "currencyType": row.currencyType,
          "goodsList": chargeReward(row.rewards),
          "image":row.image,
          "description":"",
          "dailyLimit":row.dailyLimit,
          "totalLimitNumber":row.totalLimitNumber,
          "durationLimit":row.durationLimit,
          "durationDays":row.durationDays,
          "enableFirstRecharge":row.enableFirstRecharge,
          "firstRechargeRate":row.firstRechargeRate,
          "enableDuration":row.enableDuration,
          "reEnableFirstRecharge":row.reEnableFirstRecharge,
          "reEnableFirstRechargeTime":row.reEnableFirstRechargeTime,
        };
      }
    },
    addGoods() {
      this.itemForm.goodsList.push({
        goodsId: 1,
        number:0
      })
    },
    reduceGoods(index, rows) {
      rows.splice(index, 1);
    },
    confirmForm(){
      console.log("-------->itemForm:", this.itemForm)
      let _message = '';
      if(this.itemForm.name===''){
        _message = '请输入名称'
      }else if (this.itemForm.goodsList.length<1){
        _message = '请添加奖励配置'
      }
      if(_message){
        this.$message({
          message: _message,
          type: 'error'
        });
        return;
      }
      saveRecharge(this.itemForm).then(resp=>{
        if(resp.data.status===0){
          this.search();
          this.dialogVisible=false;
        }
      });
    },
    cancelForm(){
      this.dialogVisible=false;
      this.fileList = [];
    },

    handleCISuccess(response) {
      this.itemForm.image = response.info;
    },
  },
  mounted() {
    this.VUE_APP_IOS_URL = process.env.VUE_APP_IOS_URL;
    this.VUE_APP_CDN_URL = process.env.VUE_APP_CDN_URL;
  },
  created() {
    this.headers ={Authorization : this.$store.state.user.token};
    this.queryRechargeSelections(()=>{this.search();});
  },
}
</script>

<style scoped>

</style>
